module.exports = __webpack_public_path__ + "static/media/editP.a6b06669.svg";